// @flow

import { RECEIVED_CONTACT_SETTINGS, RECEIVED_CONTACT_LABEL_SETTINGS } from './constants';
import type { ReceivedContactSettings, ReceivedContactLabelSettings } from './actions';
import type { ContactState } from './types';

const initialState: ContactState = {
  default: {
    general_number: '',
    general_email_address: '',
    street: '',
    postal_code: '',
    city: '',
    address: {
      street: '',
      postal_code: '',
      city: '',
    },
  },
  business_hours: {
    now_closed: true,
    business_hours: {
      monday: {
        closed: true,
      },
      tuesday: {
        closed: true,
      },
      wednesday: {
        closed: true,
      },
      thursday: {
        closed: true,
      },
      friday: {
        closed: true,
      },
      saturday: {
        closed: true,
      },
      sunday: {
        closed: true,
      },
    },
    deviant_business_hours: false,
    open_for_business_label: '',
  },
};

export type State = ContactState;

type Actions = ReceivedContactLabelSettings | ReceivedContactSettings;

export default (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case RECEIVED_CONTACT_SETTINGS: {
      const {
        now_closed,
        business_hours,
        deviant_business_hours,
        open_for_business_label,
        ...rest
      } = action.payload;
      return {
        ...state,
        default: {
          ...rest,
        },
        business_hours: {
          now_closed: action.payload.now_closed,
          business_hours: {
            ...action.payload.business_hours,
          },
          deviant_business_hours: action.payload.deviant_business_hours,
          open_for_business_label: action.payload.open_for_business_label,
        },
      };
    }

    case RECEIVED_CONTACT_LABEL_SETTINGS:
      return {
        ...state,
        [action.label]: {
          ...action.payload,
        },
      };
    default:
      return state;
  }
};
